import React, { FunctionComponent } from "react";
import ultPage from "ultimate-pagination";
import PageNumber from "./PageNumber";

interface PagerProps {
  currentPage: number;
  pageCount: number;
  handlePageClick: (pageNum: number, scrollToTop: boolean) => void;
  onNextPage: () => void;
  onPrevPage: () => void;
}

const Pager: FunctionComponent<PagerProps> = ({
  currentPage,
  pageCount,
  handlePageClick,
  onNextPage,
  onPrevPage,
}) => (
  <nav aria-label="pagination">
    <div className="pagination ds-u-display--flex ds-u-justify-content--between">
      {pageCount > 0 &&
        ultPage
          .getPaginationModel({
            currentPage: currentPage + 1,
            hideFirstAndLastPageLinks: true,
            totalPages: pageCount,
          })
          .map(({ type, key, value, isActive }) => (
            <React.Fragment key={key}>
              {
                {
                  [ultPage.ITEM_TYPES.PREVIOUS_PAGE_LINK]: (
                    <div className="pagination-item prev-button">
                      <button
                        aria-label="Previous Page"
                        name="prev-page"
                        id="prev-page"
                        onClick={onPrevPage}
                        hidden={currentPage === 0}
                      >
                        <span className="fa fa-chevron-left" />
                      </button>
                    </div>
                  ),
                  [ultPage.ITEM_TYPES.PAGE]: (
                    <div className="pagination-item">
                      <PageNumber
                        isActive={isActive}
                        isDisabled={value - 1 === currentPage}
                        pageNum={value - 1}
                        onClick={handlePageClick}
                      />
                    </div>
                  ),
                  [ultPage.ITEM_TYPES.ELLIPSIS]: <span>...</span>,
                  [ultPage.ITEM_TYPES.NEXT_PAGE_LINK]: (
                    <div className="pagination-item">
                      <button
                        aria-label="Next Page"
                        name="next-page"
                        id="next-page"
                        onClick={onNextPage}
                        hidden={currentPage >= pageCount - 1}
                      >
                        <span className="fa fa-chevron-right" />
                      </button>
                    </div>
                  ),
                }[type]
              }
            </React.Fragment>
          ))}
    </div>
  </nav>
);

export default Pager;
